export default __webpack_public_path__ + "static/media/quizbg.2b6096a4.png";